export default {
  UNAUTHORIZED: 401,
  NOT_ALLOWED: 403,
  CONCURRENT_EXAM: 409,
  NOT_ACTIVE_EXAM: 418,
  NOT_ACTIVE_SESSION: 420,
  NOT_IDENTIFIED: 423
};
